<template>
<template v-if="$hasPermission(`${details.listType}:read`)">
    <v-row v-if="!hideHeading"><v-col><v-divider></v-divider></v-col></v-row>

    <v-row>
        <v-col v-if="!hideHeading">
            <h3>{{props.details.heading}}</h3>
        </v-col>
        <v-col class="d-flex ga-4 justify-end" v-if="$hasPermission(`${details.listType}:create`)">
            <v-btn color="primary" variant="outlined" @click="createNew()">
                Create
            </v-btn>
        </v-col>
    </v-row>
    <v-row v-if="isSearchable">
        <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            single-line
        ></v-text-field>
    </v-row>
    <v-row>
        <v-col>
            <v-data-table
                :headers="localTableHeaders"
                :items="tableList"
                item-key="_id"
                :search="isSearchable ? search : ''"
                :items-per-page="10"
                @click:row="tableRowClick"
                :loading="isLoading"
                loading-text="Loading..."
                >
            </v-data-table>
        </v-col>
    </v-row>
</template>
</template>
<script setup>
import { useStore } from 'vuex';
import { computed, defineProps, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useTableRowClick } from "@/assets/modules/composables.js";

const props = defineProps({
    current: null,
    details: null,
    isSearchable: null,
    // Typed as Boolean so the bare `hideHeading` attribute casts to true
    // instead of the empty string.
    hideHeading: { type: Boolean, default: false },
});
const router = useRouter();
const store = useStore();
const { tableRowClick } = useTableRowClick();


const headerName = {
    title: "Name",
    key: "core.name",
    value: (row) => `${row._name}`,
};
// The Name column is prepended by default. A caller that needs Name in a
// different position can include its own "core.name" header and take over
// the full column order.
const hasOwnNameHeader = props.details.tableHeaders.some(header => header.key === headerName.key);
const localTableHeaders = hasOwnNameHeader
    ? [...props.details.tableHeaders]
    : [headerName, ...props.details.tableHeaders];

const isLoading = ref(true);

const tableList = computed(() => {
    return store.getters.getChildList( `${props.current.type}.${props.current.id}.`, props.details.listType);
})

const search = ref('');

const isSearchable = props.isSearchable ?? false;

onMounted(() => {
    fetchTableData();
})
async function fetchTableData() {
    await store.dispatch("entityGlobalList", {
        entityType: props.details.listType,
        lookupValue: `${props.current.type}-${props.current.id}`,
    });
    isLoading.value = false;
}

function createNew(){
    router.push(`/${props.current.type}/${props.current.id}/${props.details.listType}/create`);
}
</script>